/**
 * Client-side ticketing URL helper.
 * Fetches /api/dashboard/ticketing-config once per session and caches the
 * result in memory so subsequent calls (e.g. Dashboard → Visits tab) skip
 * the network round-trip.
 */

let cached: string | null = null;

export async function getTicketingUrl(token: string): Promise<string | null> {
  if (cached) return cached;
  try {
    const res = await fetch('/api/dashboard/ticketing-config', {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) return null;
    const json = await res.json();
    cached = json?.data?.ticketingUrl ?? null;
    return cached;
  } catch {
    return null;
  }
}
